var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center text-sm px-4 py-3 rounded-lg shadow-md",class:_vm.toastType.styles},[_c('span',{staticClass:"flex-grow"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }